import { useState, useEffect } from 'react';

type Breakpoints<T> = {
  xs?: T;
  sm?: T;
  md?: T;
  lg?: T;
  xl?: T;
};

const BREAK_POINTS = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export function useResponsiveValue<T>(values: Breakpoints<T>): T | undefined {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (width >= BREAK_POINTS.xl && values.xl !== undefined) return values.xl;
  if (width >= BREAK_POINTS.lg && values.lg !== undefined) return values.lg;
  if (width >= BREAK_POINTS.md && values.md !== undefined) return values.md;
  if (width >= BREAK_POINTS.sm && values.sm !== undefined) return values.sm;
  return values.xs;
}
